import type React from "react";

import { Modal, type ModalBaseProps } from "@/components/Modal/Modal";

type VideoModalProps = ModalBaseProps & {
  videoSrc: string;
};

export function VideoModal({ isOpened, onOpenChange, videoSrc }: VideoModalProps): React.ReactNode {
  return (
    <Modal.Root size="lg" {...{ isOpened, onOpenChange }}>
      <Modal.Body>
        <video
          className="mx-auto aspect-video w-full rounded-md bg-background-default-inverse object-contain"
          src={videoSrc}
          autoPlay={isOpened}
          controls
        />
      </Modal.Body>
    </Modal.Root>
  );
}
